import Glide from "@glidejs/glide";

export default class AwardsSlider {
	static init() {
		Array.prototype.forEach.call(document.querySelectorAll('.awards-slider'), el => {
			new AwardsSlider(el);
		});
	}

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.slides = this.element.querySelectorAll('.glide__slide');
		this.slidesCount = this.slides.length;
		let self = this;

		// in the Neos backend the element information is rendered in a appended script tag
		// since this script is executed after it's evaluation, we can safely remove it
		// to make the slider work properly
		const isNeosBackend = document.body.classList.contains('neos-backend');
		if (isNeosBackend) {
			Array.from(document.querySelectorAll('script[data-neos-nodedata]')).forEach((script) => script.remove())
		}

		const options = {
			peek: {before: 0, after: 0},
			gap: 8,
			arrows: false,
			rewind: false,
			type: 'slider',
			startAt: 0,
			focusAt: 0,
			perView: 6,
			bound: true,
			autoplay: false,
			breakpoints: {
				1919: {
					perView: 5
				},
				1599: {
					perView: 4
				},
				1279: {
					perView: 3
				},
				767: {
					perView: 2,
				},
				499: {
					perView: 1.5,
				}
			}
		};

		let ArrowDisable = function (Glide, Components) {
			return {
				mount() {
					// Only in effect when rewinding is disabled
					if (Glide.settings.rewind) {
						return
					}

					if (Glide.selector.parentElement.parentElement.classList.contains('category-slider')) return;

					Glide.on(['mount.after', 'run'], () => {
						// Filter out arrows_control
						for (let controlItem of Components.Controls.items) {
							if (controlItem.className !== 'glide__arrows') {
								continue
							}

							// Set left arrow state
							let left = controlItem.querySelector('.glide__arrow--left');
							if (left) {
								if (Glide.index === 0) {
									left.setAttribute('disabled', '') // Disable on first slide
								} else {
									left.removeAttribute('disabled') // Enable on other slides
								}
							}

							// Set right arrow state
							let right = controlItem.querySelector('.glide__arrow--right')
							if (right) {
								if (Glide.index >= Components.Sizes.length - Glide.settings.perView) {
									right.setAttribute('disabled', '') // Disable on last slide
								} else {
									right.removeAttribute('disabled') // Disable on other slides
								}
							}
						}
					})
				}
			}
		};

		this.slider = new Glide(this.element, options);

		this.slider.on(['build.before', 'resize'], () => {
			const barElement = self.element.querySelector('.glide__bar');
			const barThumbElement = barElement.querySelector('.glide__bar-thumb');
			let perView = window.innerWidth < 500 ? 1 : window.innerWidth < 768 ? 2 : window.innerWidth < 1280 ? 3 : window.innerWidth < 1600 ? 4 : window.innerWidth < 1920 ? 5 : 6;
			barThumbElement.style.width = perView / self.slidesCount * 100 + '%';
		});

		this.slider.mount({ArrowDisable});

		this.slider.on('run.after', function () {
			self.element.querySelector('.glide__bar')
			const barElement = self.element.querySelector('.glide__bar');
			const barThumbElement = barElement.querySelector('.glide__bar-thumb');
			barThumbElement.style.left = (1 / self.slidesCount * self.slider.index) * 100 + '%';
		});
	}
}
